import type { RootState } from '../types/store';
import getEcommercePlans from './ecommerce-plans';
import type { EcommercePlan, EcommercePlans } from '../types/ecommerce-plan';
import messenger from '../messenger';
import getMostPopularPackage from '../helpers/get-most-popular-package';

function getMostPopularEcommercePlan(state: RootState): EcommercePlan | null {
  const ecommercePlans = getEcommercePlans(state);

  if (!ecommercePlans) {
    throw new Error(messenger.missingData('ecommercePlans'));
  }

  return getMostPopularPackage<EcommercePlan, EcommercePlans>(ecommercePlans);
}

export default getMostPopularEcommercePlan;
